export interface GTMEventPayload {
  data?: object;
  eventName: string;
}

const getDataLayer = (): object[] => window[CONFIG.gtm.dataLayer] || [];

export const sendGTMEvent = ({ data, eventName }: GTMEventPayload) => {
  const gtmDataLayer = getDataLayer();

  const backWardsCompatibleData = {
    ...data,
    [eventName]: {
      firedTime: new Date().toISOString(),
      // userId: getUserId(),
      ...data,
    },
  };

  gtmDataLayer.push({
    data: backWardsCompatibleData,
    event: eventName,
  });
};

export const pushToGTMDataLayer = (payload: object) => {
  const gtmDataLayer = getDataLayer();

  gtmDataLayer.push(payload);
};
